<template>
    <div>
        <Menu :color="color" :key="color"/>
        <div id="banner" class="banner">
            <b-container>
                <b-row>
                    <b-col class="wrapper">
                        <h1>¡Tenemos un gran sueño!<br>
                            Convertirnos en la mejor compañía
                            de lentes de sol en Latinoamérica</h1>
                        <p><span class="shade1">#somos<strong>ctrendy</strong></span></p>
                        <router-link class="btn" :to="{ name: 'conocenos'}">Conócenos</router-link>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Slide/>
        <div class="section1">
            <img src="../assets/inicio/circles.png" class="img-circles" alt="">
            <b-container>
                <b-row>
                    <b-col md="12">
                        <h3>En Ctrendy, nos enorgullece tener más de 35 años de experiencia
                            iluminando miradas y protegiendo sueños, a través de la distribución
                            de lentes de sol y de lectura.</h3>
                    </b-col>
                    <b-col md="6" offset-md="6">
                        <p>Somos una familia de más de 120 colaboradores, comprometidos con llevar estilo y bienestar a cada rincón de México. Con más de 30 sucursales, atendemos con cariño y dedicación más de 15,000 puntos de venta en diferentes ciudades de nuestra hermosa República Mexicana. Juntos, trabajamos día a día para que cada par de lentes no solo sea una protección, sino una ventana a nuevas posibilidades.</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="section2">
            <b-container>
                <b-row>
                    <b-col class="mb-3 align-self-center" md="6">
                        <img class="img-fluid" src="../assets/inicio/quienessomos.png" alt="glasses">
                    </b-col>
                    <b-col class="mb-3 align-self-center" md="6">
                        <span class="hightlight">¿Quiénes somos?</span>
                        <h3 class="mt-3 mb-3">Ofrecemos la mayor variedad de modelos de lentes de sol y de lectura del mercado, así como cosméticos y maquillaje.</h3>
                        <p>Nuestros canales de distribución son flexibles y programados para satisfacer las necesidades específicas de cada cliente. Nuestra experiencia nos ha permitido desarrollar un método de trabajo único, haciendo que solicitar y dar seguimiento a los pedidos sea una experiencia sencilla y agradable para nuestros clientes.</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="section3">
            <b-container>
                <b-row>
                    <b-col class="align-self-center" md="6">
                        <span class="hightlight">¿Cómo lo hacemos?</span>
                        <h3 class="mb-3 mt-3">Con la experiencia de más de 35 años dedicados a iluminar miradas con nuestros lentes de sol y de lectura.</h3>
                        <p>Conocemos el mercado a fondo y siempre estamos a la vanguardia. Nuestra red de distribución abarca todo México, asegurando que nuestros aliados de negocio reciban sus pedidos puntualmente. Cultivamos relaciones duraderas basadas en una comunicación fluida y un servicio atento. Además, garantizamos la máxima calidad y seguridad en cada uno de nuestros productos.</p>
                    </b-col>
                    <b-col class="align-self-center" md="6">
                        <img class="img-fluid" src="../assets/inicio/imgs.png" alt="glasses">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="section4">
            <b-container>
                <b-row class="mb-3">
                    <b-col md="10">
                        <span class="hightlight">Bolsa de trabajo</span>
                        <h3 class="mb-3 mt-3">Valoramos a nuestros colaboradores y creemos en su capacidad para crecer y prosperar profesionalmente.</h3>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="mb-3" sm="3">
                        <router-link class="btn" :to="{ name: 'bolsatrabajo'}">Informacion</router-link>
                    </b-col>
                    <b-col class="mb-3">
                        <p>Ofrecemos oportunidades para desarrollar sus habilidades, explorar nuevas áreas de interés y avanzar en sus carreras. Nos enorgullece ser parte de su viaje y ver cómo cada uno de ellos alcanza su máximo potencial, construyendo juntos un mundo mejor.</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-center">
                        <img class="img-fluid" src="../assets/inicio/collage_home.png" alt="valores img">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="mapa">
            <b-container>
                <b-row>
                    <b-col class="mt-map" md="5">
                        <span class="hightlight-light">Presencia nacional</span>
                        <h3 class="mb-3 mt-3">Cobertura Ctrendy</h3>
                        <p>Ctrendy llega a cada rincón de México, con más de 32 sucursales y más de 15,000 puntos de venta, llevando estilo y protección.</p>
                        <b-form-select v-model="selected" :options="options" size="sm" class="mt-3 mb-4"></b-form-select>
                        <p class="mb-0" v-for="location in selected" :key="location">
                            <img src="../assets/inicio/vector_mapa.png" alt="icon map">  {{ location }}
                        </p>
                    </b-col>
                    <b-col md="7">
                        <img class="img-fluid" src="../assets/inicio/MAPS.png" alt="map">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="section5">
            <b-container>
                <b-row class="everest-wrapper">
                    <b-col class="mb-3 align-self-center" md="6">
                        <img class="img-fluid" src="../assets/inicio/everest.png" alt="everest img">
                    </b-col>
                    <b-col class="align-self-center" md="6">
                        <h3> <img src="../assets/inicio/Vector3.svg" alt=""> Everest el techo del mundo</h3>
                        <p>Descubre cómo nuestro visionario y fundador aplicó la filosofía de Ctrendy para alcanzar la cima del Everest, inspirando perseverancia, integridad y excelencia en cada paso.</p>
                        <a href="libro-everest.pdf" target="_blank" class="btn btn-download">Leer libro</a>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Menu from '../components/Menu.vue'
    import Footer from '../components/Footer.vue'
    import Slide from '../components/SlideBrands.vue'
    export default {
        name: 'Home',
        components: {
            Menu,
            Footer,
            Slide
        },
        data() {
            return {
                selected: null,
                options: [
                    { value: null, text: 'Estado'},
                    { value: ['Mexicali', 'Tijuana- Col. Mirador','La Paz- Fracc. Península Sur'], text: 'Baja California' },
                    { value: ['Chihuahua - Fracc. Villa de San Pedro', 'Cd. Juárez- Fracc. Porto Residencial'], text: 'Chihuahua' },
                    { value: ['Saltillo- Fracc. Saltillo 2000','Torreón- Col. Villas Universidad'], text: 'Coahuila' },
                    { value: ['Colima- Col. Villa de Álvarez'], text: 'Colima' },
                    { value: ['CDMX- Col. Campestre Guadalupana','Toluca- San Mateo Otzacatipan'], text: 'Estado de México' },
                    { value: ['Acapulco- Zona Costa Dorada'], text: 'Guerrero' },
                    { value: ['Pachuca- Fracc. Hacienda de Pitahayas'], text: 'Hidalgo' },
                    { value: ['Guadalajara- Col. Paseos de Santiago','Pto Vallarta- Col. Pacífico Azul'], text: 'Jalisco' },
                    { value: ['Morelia- Col. Francisco  Zarco'], text: 'Michoacán' },
                    { value: ['Apodaca- Fracc. Privada San Agustín','Monterrey- Fracc. Urbi Villas del Rey'], text: 'Nuevo León' },
                    { value: ['Oaxaca- Santa Cruz Xoxocotlan'], text: 'Oaxaca' },
                    { value: ['Querétaro- Col. Loma Linda'], text: 'Querétaro' },
                    { value: ['Puebla- Fracc. Real del Bosque'], text: 'Puebla' },
                    { value: ['Cancún- Fracc. Leonardo R. Alcaine'], text: 'Quintana Roo' },
                    { value: ['San Luis Potosí- Col. Hacienda de los Morales'], text: 'San Luis Potosí' },
                    { value: ['Culiacán- Fracc. Country del Río'], text: 'Sinaloa' },
                    { value: ['Villahermosa- Fracc. San Ángel'], text: 'Tabasco' },
                    { value: ['Reynosa- Col. Vistahermosa','Tampico- Col. Tamaulipas'], text: 'Tamaulipas' },
                    { value: ['Veracruz- Fracc. Laguna Real'], text: 'Veracruz' },
                    { value: ['Mérida- Fracc. Los Héroes'], text: 'Yucatán' },
                    { value: ['Zacatecas- Fracc. Mina Azul'], text: 'Zacatecas' },
                ],
                color: 'transparent',
            }
        },
        methods: {
            handleScroll(){
                var stop= document.querySelector('#banner');
                if(window.scrollY > stop.offsetTop){
                    this.color = 'orange';
                    } else {
                    this.color = 'transparent';
                }
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll, true)
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll, true)
        },
    }
</script>

<style scoped>
h3{
  font-size: 35px;
  font-weight: 400;
}
p{
    font-size: 20px;
    line-height: 25px;
}
/* BANNER */
.banner{
    min-height: 100vh;
    background-image: url('../assets/inicio/img_banner.png'); /* The image used */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    text-align: center;
}
.banner h1{
    font-size: 65px;
    color: #fff;
}
.banner p{
    font-size: 40px;
    text-transform: uppercase;
}
.banner  .shade1{
    color: #9DF002;
    font-weight: 400;
}
.banner  .shade2{
    color: #B6F0FF;
}
.banner  .shade3{
    color: #B6F0FF;
    font-weight: 700;
}
.banner  .shade4{
    color: #386CE7;
    font-weight: 700;
}
.banner .row{
    min-height:100vh;
    position: relative;
}
.banner .wrapper{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.banner .btn{
    margin-top: 20px;
    color: #fff !important;
    background: #16B7C2 !important;
    border: none;
    font-size: 25px;
    width: 100%;
    max-width: 285px;
}

/* SECTION 1 */
.section1{
    padding: 85px 0;
    background: #001824;
    color: #fff;
    text-align: justify;
    position: relative;
}
.img-circles{
    position: absolute;
    bottom: 0;
    left: 5%;
}

/* SECTION 2 */
.section2{
    padding: 85px 10%;
    text-align: justify;
    position: relative;
}

/* SECTION 3 */
.section3{
    padding: 85px 0;
    text-align: justify;
    position: relative;
}

/* SECTION 4 */
.section4{
    padding: 80px 0;
}
.section4 .btn{
    color: #fff !important;
    background: #FC5300 !important;
    border: none;
    padding: 17px;
    font-size: 25px;
    width: 100%;
}

/* MAPA */
.mapa{
    background: #001824;
    padding: 0 0 50px 0;
    color: #fff;
}
.mt-map{
    margin-top: 100px;
}


/* SECTION 5 */
.section5{
    padding: 85px 0;
    text-align: justify;
}
.everest-wrapper{
    background: #16B7C2;
    border-radius: 20px;
    padding: 70px 7%;
}
.btn-download{
    background: #2164D8 !important;
    color: #fff !important;
    font-size: 25px;
    padding: 10px;
    width: 100%;
    max-width: 285px;
}
.btn-download:focus,
.btn-download:hover,
.btn-download:active{
    background: #000 !important;
    color: #fff !important;
}
@media (max-width: 768px){
    h3{
        font-size: 27px;
        line-height: 1;
        font-weight: 400;
    }
    p{
        font-size: 18px;
        line-height: 20px;
    }
    /* BANNER */
    .banner h1{
        font-size: 45px;
        color: #fff;
    }
    .banner p{
        font-size: 30px;
        text-transform: uppercase;
    }
    .banner .btn{
        font-size: 20px;
    }

    /* SECTION 1 */
    .section1{
        padding: 85px 7%;
    }
    .img-circles{
        display: none;
    }

    /* SECTION 2 */
    .section2{
        padding: 85px 10% 0 10%;
        text-align: justify;
        position: relative;
    }

    /* SECTION 3 */
    .section3{
        padding: 85px 7%;
        text-align: justify;
        position: relative;
    }

    /* SECTION 4 */
    .section4{
        padding: 80px 7%;
    }
    .section4 .btn{
        color: #fff;
        background: #386CE7;
        border: none;
        padding: 17px;
        font-size: 25px;
        width: 100%;
    }

    /* MAPA */
    .mapa{
        background: #386CE7;
        padding: 0 7% 50px 7%;
        color: #fff;
    }
    .mt-map{
        margin-top: 100px;
    }


    /* SECTION 5 */
    .section5{
        padding: 85px 7%;
        text-align: justify;
    }
    .everest-wrapper{
        background: #B7EFFF;
        border-radius: 20px;
        padding: 70px 7%;
    }
    .btn-download{
        font-size: 20px;
    }

}
</style>